// extracted by mini-css-extract-plugin
module.exports = {"PlateIcon":"PlateIcon_PlateIcon__1grxU"};